import * as XLSX from "xlsx";

function getValueByPath(obj: any, path: string): any {
    if (!obj || !path) return "";
    return path.split(".").reduce((current, key) => {
        if (current == null) return "";
        if (Array.isArray(current)) {
            return current.map(item => item?.[key]);
        }
        return current[key];
    }, obj);
}

export function generateDynamicExcelObject(
    patientData: any,
    excelMapping: Record<string, string>
) {
    const flattenedResult: Record<string, any> = {};
    const interleavedIndexBuckets: Record<string, any>[] = [];

    // Single loop over the mapping keys to process each field once
    for (const mappingKey in excelMapping) {
        const columnPath = excelMapping[mappingKey];
        const extractedValue = getValueByPath(patientData, columnPath);

        if (Array.isArray(extractedValue)) {
            // Once we get an array, we distribute its items into separate buckets for each index
            extractedValue.forEach((itemValue, itemIndex) => {
                if (!interleavedIndexBuckets[itemIndex]) {
                    interleavedIndexBuckets[itemIndex] = {};
                }
                const fieldNameWithSuffix = `${mappingKey} ${itemIndex + 1}`;
                interleavedIndexBuckets[itemIndex][fieldNameWithSuffix] = itemValue ?? "";
            });


        } else {
            // For static fields, we add them directly to the start of the result
            flattenedResult[mappingKey] = extractedValue ?? "";
        }
    }

    // Combine static fields and each index bucket in order.
    // This preserves sequence: [Static Fields] -> [Index 1 All] -> [Index 2 All] ...
    return Object.assign(flattenedResult, ...interleavedIndexBuckets);
}


export function exportExcel(
    data: Record<string, any>,
    fileName: string = "patient-data.xlsx"
) {

    const worksheet = XLSX.utils.json_to_sheet([data]);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Patient Data"
    );

    XLSX.writeFile(workbook, fileName);
}